export const PASSWORD = {
  REQUIRED_FIELD: 'Please fill out this field',
  REQUIRED_CONFIRM_PWD: 'The two passwords that you entered do not match',
  REQUIRED_DUPLICATE_PWD: 'New Password must be not the same Old Password',
  REQUIRED_PASSWORD:
    'Password must be from 8 to 30 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character'
};
